<template>
  <WidgetPanel>
    <template #header>
      <h3 class="widget-headline">
        Notizen
      </h3>
    </template>
    <template #default>
      <section v-if="empty">
        <div class="px-4 py-5 sm:px-6">
          <p class="mt-1 max-w-2xl text-sm text-gray-500">
            Bisher wurden noch keine Notizen hinterlassen...
          </p>
        </div>
      </section>
      <section v-else="empty">
        <div class="divide-y divide-gray-200">
          <div class="px-4 py-6 sm:px-6">
            <ul role="list" class="space-y-8">
              <CommentWidgetItem v-for="c in results" :key="c.id" :comment="c" as="li" />
            </ul>
          </div>
        </div>
      </section>
      <section>
        <CommentWidgetPrompt :experiment="experiment" @updated="onUpdate" />
      </section>
    </template>
  </WidgetPanel>
</template>

<script setup>
import { computed, onMounted, watch } from 'vue';
import { useFetchResources } from '@/client/actions';

const props = defineProps({experiment: Object});

const parent = computed(() => props.experiment.id);
const target = computed(() => '/api/experiments/' + parent.value + '/comments');
const action = useFetchResources(target);

const { results, fetch, fetching, empty } = action;

const onUpdate = () => fetch();
const onChange = watch(parent, (_) => fetch());
const onMount = onMounted(fetch);
</script>
